/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Export_FailedInputs */

const vi_order_export_failed = /** @type {(inputs: Order_Export_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không thể xuất Excel đơn hàng`)
};

/**

* @param {Order_Export_FailedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_export_failed = /** @type {((inputs?: Order_Export_FailedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Export_FailedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_export_failed(inputs)
});